/* percentText.js -- ONE RULE FOR A PERCENTAGE TYPED IN A BOX: 0 to 100, at most two decimals, stored as a FRACTION (2.95 -> 0.0295).
 *
 * Extracted 2026-10-27 from utils/implBasis.js (the "% of new ACV" box, step 3), which now delegates here unchanged, so the Vendor
 * Modal's "% of Revenue" box (Brian B5) is the SAME rule rather than a copy. Each box supplies its own three messages.
 * The text is kept as typed and parsed here: blank -> the box's `required` message; not a plain non-negative number, or outside
 * 0-100 -> `range`; a THIRD decimal -> `precision` -- refused, not rounded (the columns hold 4 decimals of the fraction = 2 of a
 * percent, and the operator's number is never changed). 0 is an answer. */

// the typed text -> { rate: a fraction in [0, 1], error: null } | { rate: null, error: <message> }
export function parsePercentText(text, messages) {
  const t = String(text == null ? '' : text).trim();
  if (t === '') return { rate: null, error: messages.required };
  if (!/^(\d+(\.\d*)?|\.\d+)$/.test(t)) return { rate: null, error: messages.range };
  const pct = Number(t);
  if (!Number.isFinite(pct) || pct < 0 || pct > 100) return { rate: null, error: messages.range };
  if (/\.\d{3,}$/.test(t)) return { rate: null, error: messages.precision };
  return { rate: Math.round(pct * 100) / 10000, error: null };
}

// a stored fraction -> the box's text (0.2 -> "20", 0.1725 -> "17.25", 0 -> "0"); '' when there is no number
export function percentText(rate) {
  const n = Number(rate);
  if (rate === null || rate === undefined || rate === '' || !Number.isFinite(n)) return '';
  return String(Math.round(n * 1000000) / 10000);
}
